var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showRow)?_c('li',{staticClass:"list-group-item"},[(_vm.showButton)?_c('button',{staticClass:"btn",class:_vm.styling,on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.buttonLabel))]):_vm._e(),_vm._v("  "+_vm._s(_vm.content)+"\n\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }